export default __webpack_public_path__ + "static/media/dot-green.95898848.svg";